<h1 mat-dialog-title>
    {{ data.mode === 'move' ? 'Move Package to New Position' : 'Remove Package from Position' }}
</h1>
<div mat-dialog-content class="modal-content">
    <form [formGroup]="form">
        <!-- Autocomplete for Position -->
        <mat-form-field class="form-field" *ngIf="data.mode === 'move'">
            <input type="text" matInput placeholder="Enter Position Name" formControlName="selectedPosition"
                [matAutocomplete]="auto">
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let position of filteredPositions | async"
                    [value]="position.inventory_position_name">
                    {{ position.inventory_position_name }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>

        <!-- Select Package -->
        <mat-form-field class="form-field">
            <mat-label>Select Package</mat-label>
            <mat-select formControlName="package_uuid">
                <mat-option *ngFor="let package of packages" [value]="package.package_uuid">
                    {{ package.contact_organization }} - {{ package.model }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </form>
</div>
<div mat-dialog-actions class="modal-actions">
    <button mat-button (click)="onClose()">Cancel</button>
    <button mat-button color="primary" [disabled]="form.invalid" (click)="save()">Save</button>
</div>